import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { RESULT_TYPE } from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

export const mergeSearchResultsByType = ({
  previousResults,
  incomingResults,
  resultType,
}: {
  previousResults: SearchResultList<ResultSearchType>[];
  incomingResults: SearchResultList<ResultSearchType>[];
  resultType: RESULT_TYPE;
}): SearchResultList<ResultSearchType>[] => {
  const incomingSection = incomingResults.find(
    (section) => section.type === resultType,
  );

  if (!incomingSection) {
    return previousResults;
  }

  const hasPreviousSection = previousResults.some(
    (section) => section.type === resultType,
  );

  if (!hasPreviousSection) {
    return [...previousResults, incomingSection];
  }

  return previousResults.map((section) =>
    section.type === resultType ? incomingSection : section,
  );
};
